import {Prompt, PicLink, EventBanner, Quicklink, EventResources, ScrollReset} from './obj.js'

import poster1 from './img/SPPC/SPP_SPAR2025_Flyer_DIGITAL_DesignB-724x1024.webp'
import poster2 from './img/SPPC/SPP_SPAR2025_Flyer_DIGITAL_DesignD.webp'
import photo1 from './img/SPPC/UNSW_ICPC-23_Amy-Piddington-0035-1024x683.webp'
import photo2 from './img/SPPC/UNSW_ICPC_Amy-Piddington-028-1024x683.webp'

import spcpa from './icons/SPCPA_white.png'
import alg from './icons/compalg.png'

export default function SPPC(){
    return (<>
        <main className = "eventpage">
            <ScrollReset/>
            <EventBanner>Weekly<br/>Workshops</EventBanner>
            <section className= "twocol">
                <Prompt text = "Workshops >>">The annual SPPC is organised by SPCPA and acts as qualifying rounds for ICPC, the preeminent university level competitive programming competition. In SPPC, teams of up to 3 students compete against other universities to secure an ICPC placement. This competition represents the culmination of years of training for many competitive programming students. 
                </Prompt>
                <div className = 'twobytwo'>
                    <PicLink src = {poster1}></PicLink>
                    <PicLink src = {photo1}></PicLink>
                    <PicLink src = {photo2}></PicLink>
                    <PicLink src = {poster2}></PicLink>
                </div>
            </section>
            <section className= "twocol">

                <EventResources>
                    <Quicklink src = {spcpa} path = 'https://prog4fun.csse.canterbury.ac.nz/'>SPAR Judge</Quicklink>
                    <Quicklink src = {spcpa} path = 'https://sppcontests.org/'>SPCPA</Quicklink>
                    <Quicklink src = {alg} path = 'https://cp-algorithms.com/'>CP-Algorithms</Quicklink>
                </EventResources>
            </section>

        </main>
    </>)
}